// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mNDU","name":"styles_name__2SDXa","phone":"styles_phone__1EfHX"};